import { useLang } from "../../lib/i18n";

export const Marquee = () => {
    const { t } = useLang();
    return (
        <div data-testid="editorial-marquee" className="overflow-hidden border-y border-white/10 bg-night-900/60 py-5">
            <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
                {[...t.marquee, ...t.marquee].map((item, i) => (
                    <span key={i} className="flex items-center gap-10">
                        <span className="font-display font-wide text-sm font-bold uppercase tracking-[0.22em] text-slate-400">
                            {item}
                        </span>
                        <span className="font-mono text-amber-400">✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
};
